import { useEffect, useState } from "react";
import fetchData from "../../../shared/fetchData";
import Button from "../../../components/UI/Button/Button";
import PasswordReq from "../../../components/RentGrid/PasswordReq/PasswordReq";
import { Collapse } from "@material-ui/core";
import { toast } from "react-toastify";
import ShowPassword from "./ShowPassword";

const ShowRentOrders = (props) => {
    const [orders, setOrders] = useState([]);
    const [orderNumber, setOrderNumber] = useState('');
    const prmsn = window.localStorage.getItem("permission");
    const [showPassword, setShowPassword] = useState(false);
    const [showGetPassword, setShowGetPassword] = useState(false);
    const [orderId, setOrderId] = useState('');

    useEffect(() => {
        var info = {
            "rent": {
                "id": props.id
            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/rents/searchRentOrders'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setOrders(result.orders)
            })
            .catch(error => console.log(error))
    }, [])
    const passwordRequest = (event, orderNumber) => {
        setOrderNumber(orderNumber);
        setShowPassword(true);
        // <PasswordReq putError={putError} closeModal={closePasswordModal} orderNumber={ordNumber} />
    }
    const showPasswords = (event, ordId) => {
        setOrderId(ordId);
        setShowGetPassword(true);
    }
    return (
        <>
            <Collapse in={!showPassword && !showGetPassword} >

                {
                    orders.map(o => {
                        return (
                            <div className="row justify-content-center" style={{ minWidth: '900px' }}>
                                <div className="rent-cntnr mt-3" style={{ width: '100%' }}>
                                    <div className="row justify-content-center mt-3">
                                        <div className="col-5 full-small">
                                            <div className="row justify-content-center">
                                                <div className="col-6 small-ord-col">
                                                    شماره سفارش:
                                                </div>
                                                <div className="col-6 small-ord-col">
                                                    {o.orderNumber}
                                                </div>
                                            </div>
                                            <div className="row justify-content-center">
                                                <div className="col-6 small-ord-col">
                                                    سریال باکس:
                                                </div>
                                                <div className="col-6 small-ord-col">
                                                    {o.locker != null ? o.locker.serial : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-5 full-small">
                                            <div className="row justify-content-center">
                                                {props.hasPassOperation != null && props.hasPassOperation ?
                                                    <>
                                                        {prmsn.split(",").includes("CUSTOMER_WRITE") ?
                                                            '' :
                                                            <div className="col-6 small-ord-col">
                                                                <Button btnType="General" clicked={(event) => passwordRequest(event, o.orderNumber)}>درخواست رمز</Button>
                                                            </div>
                                                        }
                                                    </>
                                                    : ''}
                                                {props.hasPassOperation != null && props.hasPassOperation ?
                                                    <div className="col-6 small-ord-col">
                                                        <Button btnType="General" clicked={(event) => showPasswords(event, o.id)}>مشاهده رمز</Button>
                                                    </div>
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </Collapse>
            <Collapse in={showPassword} >
                {showPassword ?
                    <div className="row justify-content-center w-100 ml-0 mr-0">
                        <PasswordReq putError={() => toast.error('وضعیت سفارش صحیح نیست')} closeModal={() => setShowPassword(false)} orderNumber={orderNumber} />
                    </div>
                    : ''}
            </Collapse>
            <Collapse in={showGetPassword} >
                {showGetPassword ?
                    <div className="row justify-content-center w-100 ml-0 mr-0">
                        <ShowPassword orderId={orderId} closeModal={() => setShowGetPassword(false)} />
                    </div>
                    : ''}
            </Collapse>
        </>
    )
}
export default ShowRentOrders;